// import jQuery from 'CommonScripts/jquery-1.10.2';
(function (window, document, $) {

    $(document).ready(function () {
        // see dropdown
        var more = document.getElementById("dropdownOpen") || undefined;

        if (more !== undefined) {
            more.addEventListener('click', function (e) {
                e.preventDefault();
                if (this.className === 'open') {
                    this.className = '';
                    document.getElementById("dropdownContainer").removeAttribute('style');
                } else {
                    this.className = 'open';
                    document.getElementById("dropdownContainer").style.height = document.getElementById("dropdownCont").offsetHeight + "px";
                    //GTM
                    dataLayer.push({
                        'event': 'interactionevent',
                        'eventcategory': 'Home page drop down button',
                        'eventaction': 'click',
                        'eventlabel': 'drop down open'
                    });
                }
            }, false);
        }

        //GTM
        var rm = document.querySelectorAll('.dropdownItem a');

        if (rm.length) {
            for (var i = 0; i < rm.length; ++i) {
                rm[i].addEventListener('click', function (e) {
                    dataLayer.push({
                        'event': 'interactionevent',
                        'eventcategory': 'Home Page drop down button',
                        'eventaction': 'click',
                        'eventlabel': this.href
                    });

                }, false);
            }
        }

    });

})(window, document, jQuery);
